import React, { type PropsWithChildren } from 'react';
import { Text } from '@atlaskit/primitives/compiled';
import { fg } from '@atlassian/jira-feature-gating';

export const CommentSubtext = ({ children }: PropsWithChildren) => {
	if (!fg('jira_custom_comment_component_refactor')) {
		return children;
	}
	return (
		<Text size="small" color="color.text.subtlest">
			{children}
		</Text>
	);
};

export default CommentSubtext;
